import React from 'react'
import { Icon } from 'antd'
import {
  getSourceIcon,
  getVoiceSubtitle,
  getVoiceMetaBadges,
  getVoiceReasoningPreview,
  getVoiceGenderTag,
  getVoiceGenderLabel
} from '../utils'

const VoiceListItem = ({
  voice,
  variant,
  displayName,
  isSelected,
  isPlaying,
  progress,
  onSelect,
  onPlay,
  onViewDetails,
  canDelete = false,
  onDelete
}) => {
  const sourceIcon = getSourceIcon(variant)
  const subtitle = getVoiceSubtitle(voice, variant)
  const metaBadges = getVoiceMetaBadges(voice)
  const shouldShowMetaBadges = variant !== 'system'
  const genderTag = getVoiceGenderTag(voice)
  const genderLabel = getVoiceGenderLabel(voice)
  const reasoningPreview =
    variant === 'recommended' ? getVoiceReasoningPreview(voice) : ''

  const actions = (
    <div className="voiceover-card__actions">
      <button
        className="voiceover-card__icon-btn"
        onClick={e => {
          e.stopPropagation()
          onViewDetails()
        }}
        type="button"
        aria-label={`View details for ${displayName}`}
      >
        <Icon type="eye" />
      </button>
      <div
        className={`voiceover-card__play-wrapper ${
          isPlaying ? 'voiceover-card__play-wrapper--playing' : ''
        }`}
        style={{
          position: 'relative',
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          overflow: 'hidden'
        }}
      >
        {isPlaying && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `conic-gradient(#5057d5 ${progress}%, #eef0ff 0)`,
              zIndex: 0
            }}
          />
        )}
        <button
          className={`voiceover-card__play-btn ${
            isPlaying ? 'voiceover-card__play-btn--playing' : ''
          }`}
          onClick={e => {
            e.stopPropagation()
            onPlay()
          }}
          style={
            isPlaying
              ? {
                  position: 'absolute',
                  top: '3px',
                  left: '3px',
                  right: '3px',
                  bottom: '3px',
                  width: 'calc(100% - 6px)',
                  height: 'calc(100% - 6px)',
                  zIndex: 1,
                  borderRadius: '50%',
                  background: '#ffffff',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }
              : {}
          }
          type="button"
        >
          <Icon
            type={isPlaying ? 'pause' : 'caret-right'}
            style={isPlaying ? { color: '#5057d5', fontSize: '14px' } : {}}
          />
        </button>
      </div>

      <button
        className={`voiceover-card__select-btn ${
          isSelected ? 'voiceover-card__select-btn--selected' : ''
        }`}
        onClick={e => {
          e.stopPropagation()
          onSelect()
        }}
        type="button"
      >
        {isSelected && <Icon type="check" />}
        <span>{isSelected ? 'Selected' : 'Select'}</span>
      </button>
      {canDelete && typeof onDelete === 'function' && (
        <button
          className="voiceover-card__icon-btn"
          onClick={e => {
            e.stopPropagation()
            onDelete()
          }}
          type="button"
          aria-label={`Delete ${displayName}`}
          title="Delete voice"
        >
          <Icon type="delete" style={{ color: '#cf1322' }} />
        </button>
      )}
    </div>
  )

  if (variant === 'system' || variant === 'custom') {
    return (
      <div
        className={`voiceover-card voiceover-card--${variant} ${
          isSelected ? 'voiceover-card--selected' : ''
        }`}
        onClick={onSelect}
      >
        <div className="voiceover-card__voice-col">
          <div
            className={`voiceover-card__source voiceover-card__source--${variant}`}
          >
            <Icon type={sourceIcon} />
          </div>
          <span className="voiceover-card__name">{displayName}</span>
        </div>

        <div className="voiceover-card__gender-col">
          <span
            className="voiceover-card__gender-tag"
            title={genderLabel || 'Unknown'}
          >
            {genderTag}
          </span>
        </div>

        {actions}
      </div>
    )
  }

  return (
    <div
      className={`voiceover-card voiceover-card--${variant} ${
        isSelected ? 'voiceover-card--selected' : ''
      }`}
      onClick={onSelect}
    >
      <div className="voiceover-card__identity">
        <div
          className={`voiceover-card__source voiceover-card__source--${variant}`}
        >
          <Icon type={sourceIcon} />
        </div>
      </div>

      <div className="voiceover-card__content">
        <div className="voiceover-card__title-row">
          <div className="voiceover-card__title-block">
            <span className="voiceover-card__name">{displayName}</span>
          </div>
        </div>

        {!!subtitle && (
          <span className="voiceover-card__subtitle">{subtitle}</span>
        )}
        {reasoningPreview && (
          <span className="voiceover-card__reasoning">{reasoningPreview}</span>
        )}
        {shouldShowMetaBadges && metaBadges.length > 0 && (
          <div className="voiceover-card__meta">
            {metaBadges.map(item => (
              <span className="voiceover-card__meta-pill" key={item.key}>
                <strong>{item.label}:</strong> {item.value}
              </span>
            ))}
          </div>
        )}
      </div>

      {actions}
    </div>
  )
}

export default VoiceListItem
